import React from 'react';
import { Link } from 'react-router-dom';

export default function Home() {
  return (
    <>
      {/* Hero Section */}
      <header className="relative min-h-screen flex items-center pt-20 pb-20 overflow-hidden">
        {/* Background Image */}
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: 'url(/hero-bg.webp)' }}
        />
        {/* Overlay for better text readability */}
        <div className="absolute inset-0 bg-[#f5f0e5]/70" />
        
        <div className="max-w-6xl mx-auto px-5 w-full relative z-10">
          <div className="max-w-3xl ml-0">
            <span className="inline-block px-5 py-2 bg-[#a4cc3a] text-[#1f4a4a] text-sm font-semibold rounded-full mb-6">
              Specialist in GGZ-ondersteuning
            </span>
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight mb-6">
              Professionele psychiatrische zorg{' '}
              <span className="text-[#2d5e5e] relative">
                op maat
                <span className="absolute bottom-1 left-0 w-full h-2 bg-[#a4cc3a] opacity-30 -z-10" />
              </span>
            </h1>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Wij versterken GGZ-instellingen met hoogwaardige, flexibele psychiatrische expertise.
              Transparant, deskundig en altijd gericht op kwaliteit.
            </p>
            <div className="flex flex-wrap gap-5 mb-10">
              <div className="flex items-center gap-2 text-gray-700 font-medium">
                <i className="fas fa-check-circle text-[#a4cc3a]"></i>
                Flexibele inzet
              </div>
              <div className="flex items-center gap-2 text-gray-700 font-medium">
                <i className="fas fa-check-circle text-[#a4cc3a]"></i>
                Transparante kosten
              </div>
              <div className="flex items-center gap-2 text-gray-700 font-medium">
                <i className="fas fa-check-circle text-[#a4cc3a]"></i>
                Geen langdurige verplichtingen
              </div>
            </div>
            <div className="flex flex-wrap gap-4">
              <Link to="/contact" className="btn-primary">
                Neem contact op
              </Link>
              <Link to="/offerte" className="btn-accent">
                Vraag offerte aan
              </Link>
            </div>
          </div>
        </div>
        <div className="absolute bottom-10 left-1/2 -translate-x-1/2 animate-bounce">
          <a href="#intro" className="flex items-center justify-center w-12 h-12 bg-white rounded-full shadow-md text-[#2d5e5e] hover:bg-[#2d5e5e] hover:text-white transition-all">
            <i className="fas fa-chevron-down"></i>
          </a>
        </div>
      </header>

      {/* Intro Section */}
      <section id="intro" className="py-24 bg-gray-100">
        <div className="max-w-6xl mx-auto px-5">
          <div className="grid md:grid-cols-2 gap-16 items-center">
            <div>
              <span className="inline-block px-4 py-1.5 bg-[#a4cc3a] text-[#1f4a4a] text-sm font-semibold rounded-full mb-4">
                Wie zijn wij?
              </span>
              <h2 className="text-3xl font-bold text-gray-900 mb-5">PUUR Psychiatrie</h2>
              <p className="text-lg text-gray-700 font-medium mb-4">
                Een gespecialiseerd bureau dat zich volledig richt op het leveren van
                hoogwaardige psychiatrische zorg binnen GGZ-instellingen.
              </p>
              <p className="text-gray-600 mb-6">
                Wij bieden geen patiëntgerichte praktijk, maar ondersteunen instellingen die waarde hechten
                aan persoonlijke aandacht en inhoudelijke versterking van hun behandelteam.
              </p>
              <Link to="/over-ons" className="btn-outline">
                Meer over ons <i className="fas fa-arrow-right"></i>
              </Link>
            </div>
            <div className="space-y-5">
              <div className="bg-white rounded-xl p-8 shadow-md border border-gray-200 hover:shadow-lg hover:border-[#a4cc3a] transition-all hover:-translate-y-1">
                <i className="fas fa-ticket-alt text-3xl text-[#2d5e5e] mb-4"></i>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">Strippenkaart model</h3>
                <p className="text-gray-600 mb-4">Flexibele ureninkoop met volledige transparantie</p>
                <Link to="/ons-model" className="text-[#2d5e5e] font-semibold hover:text-[#a4cc3a] transition-colors">
                  Bekijk ons model <i className="fas fa-arrow-right"></i>
                </Link>
              </div>
              <div className="bg-white rounded-xl p-8 shadow-md border border-gray-200 hover:shadow-lg hover:border-[#a4cc3a] transition-all hover:-translate-y-1">
                <i className="fas fa-stethoscope text-3xl text-[#2d5e5e] mb-4"></i>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">Onze diensten</h3>
                <p className="text-gray-600 mb-4">Van consultatie tot regiebehandelaarschap</p>
                <Link to="/diensten" className="text-[#2d5e5e] font-semibold hover:text-[#a4cc3a] transition-colors">
                  Bekijk diensten <i className="fas fa-arrow-right"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-[#2d5e5e]">
        <div className="max-w-6xl mx-auto px-5 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">Klaar om samen te werken?</h2>
          <p className="text-white/90 text-lg mb-8">Neem vrijblijvend contact met ons op of vraag direct een offerte aan.</p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/contact" className="btn-white">
              <i className="fas fa-envelope"></i> Neem contact op
            </Link>
            <Link to="/offerte" className="btn-accent">
              <i className="fas fa-file-invoice"></i> Vraag offerte aan
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
